/* reye-sc1.js: cart wiring for the Reye Vision style test page.
   Every button does what its label says:
   - "Buy now" (or "Buy it now" / "Order now"): adds the item, then goes straight to checkout.
   - Anything else (Add to cart): adds the item, then opens the theme's cart drawer (or the cart page).
   If the store says no, a clear message shows next to the button. */
(function () {
  if (window.reyeSc1) return;

  var BUY_NOW = /\b(buy|order)\s+(it\s+)?now\b/i;
  function wantsCheckout(el) {
    return !!el && (el.hasAttribute('data-reye-sc1-checkout') || BUY_NOW.test(el.textContent || ''));
  }

  var busyStyle = document.createElement('style');
  busyStyle.textContent = '[data-reye-sc1-atc][aria-busy="true"],[data-reye-sc1-cta][aria-busy="true"]{opacity:.75;cursor:progress;pointer-events:none}' +
    '[data-reye-sc1-atc][aria-busy="true"]::after,[data-reye-sc1-cta][aria-busy="true"]::after{content:"";flex:none;width:16px;height:16px;margin-left:10px;border:2.5px solid currentColor;border-right-color:transparent;border-radius:50%;animation:reye-sc1-spin .7s linear infinite}' +
    '@keyframes reye-sc1-spin{to{transform:rotate(360deg)}}';
  document.head.appendChild(busyStyle);

  function currentVariantId(fallback) {
    var input = document.querySelector('[data-reye-sc1-form] input[name="id"]:checked') ||
                document.querySelector('[data-reye-sc1-form] input[name="id"][type="hidden"]');
    return (input && input.value) || fallback;
  }

  var toastTimer;
  function clearError() {
    var inline = document.querySelector('[data-reye-sc1-error]');
    if (inline) inline.hidden = true;
    var toast = document.querySelector('[data-reye-sc1-toast]');
    if (toast) toast.style.display = 'none';
  }

  function showError(message, btn) {
    var inline = document.querySelector('[data-reye-sc1-error]');
    if (inline && btn && btn.closest && btn.closest('[data-reye-sc1-form]')) {
      inline.textContent = message;
      inline.hidden = false;
      return;
    }
    var toast = document.querySelector('[data-reye-sc1-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('data-reye-sc1-toast', '');
      toast.setAttribute('role', 'alert');
      toast.style.cssText = 'position:fixed;left:50%;top:16px;transform:translateX(-50%);z-index:100000;box-sizing:border-box;width:min(92vw,420px);padding:14px 18px;background:#fff;color:#161616;border:2px solid #fa651f;border-radius:16px;box-shadow:0 8px 28px rgba(0,0,0,.18);font:600 15px/1.4 Inter,system-ui,sans-serif;text-align:center;cursor:pointer;display:none';
      toast.addEventListener('click', function () { toast.style.display = 'none'; });
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.display = 'block';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.style.display = 'none'; }, 9000);
  }

  function explain(res, data) {
    var detail = (data && (data.description || data.message)) || '';
    if (res.status === 404) {
      return "We couldn't add this to your cart right now. Please try again in a moment." + (detail ? ' (' + detail + ')' : '');
    }
    return detail || "We couldn't add this to your cart. Please try again.";
  }

  async function addToCart(id, quantity, btn, opts) {
    opts = opts || {};
    if (btn && btn.getAttribute('aria-busy') === 'true') return false;
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    if (btn) btn.setAttribute('aria-busy', 'true');
    clearError();
    var leaving = false;
    try {
      var res;
      try {
        res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }], sections: sections, sections_url: window.location.pathname })
        });
      } catch (netErr) {
        showError("We couldn't reach the store. Please check your connection and try again.", btn);
        return false;
      }
      var data = {};
      try { data = await res.json(); } catch (parseErr) { data = {}; }
      if (!res.ok) {
        console.error('[reye-sc1] add to cart failed', res.status, data);
        showError(explain(res, data), btn);
        return false;
      }
      if (opts.checkout) {
        leaving = true;
        window.location.href = '/checkout';
        return true;
      }
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        try {
          drawer.renderContents(data);
          return true;
        } catch (drawerErr) {
          console.error('[reye-sc1] cart drawer failed, opening the cart page', drawerErr);
        }
      }
      leaving = true;
      window.location.href = '/cart';
      return true;
    } finally {
      if (btn && !leaving) btn.removeAttribute('aria-busy');
    }
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[aria-busy="true"]').forEach(function (el) { el.removeAttribute('aria-busy'); });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-reye-sc1-form]');
    if (!form) return;
    e.preventDefault();
    var qty = form.querySelector('[name="quantity"]');
    var btn = e.submitter || form.querySelector('[type="submit"]');
    addToCart(currentVariantId(), qty ? qty.value : 1, btn, { checkout: wantsCheckout(btn) });
  });

  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-reye-sc1-cta]');
    if (cta) {
      e.preventDefault();
      var qty = document.querySelector('[data-reye-sc1-form] [name="quantity"]');
      var quantity = cta.dataset.quantity || (qty ? qty.value : 1);
      addToCart(currentVariantId(cta.dataset.variantId), quantity, cta, { checkout: wantsCheckout(cta) });
      return;
    }
    var step = e.target.closest('[data-reye-sc1-qty]');
    if (step) {
      var input = step.parentElement.querySelector('input');
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.reyeSc1Qty));
      input.value = next;
    }
  });

  window.reyeSc1 = { addToCart: addToCart };
})();
